import React from "react";
import { Image, ImageProps } from "@chakra-ui/react";

export const DesktopBanner = React.memo((props: ImageProps) => {
  return (
    <Image
      cursor="pointer"
      src={require("assets/wedding-card.png")}
      {...props}
    />
  );
});
